import visit from 'unist-util-visit';
import stringify from 'nlcst-to-string';
import transistionalWords from './TransitionalWords.json';
import { TextAnalysis, TextAnalysisCategory, TextAnalysisResult } from '../SermonAnalyzer';


export default function TransitionalWords() {
    let transitionalWordRegex = new RegExp(transistionalWords.join('|'), 'gi');

    let totalSentanceCount:number = 0;
    let transitionalPhraseCount:number = 0;

    return transformer
    
    function transformer(tree: any, file: any) {
        
        visit(tree, 'SentenceNode', search);
        
        function search(sentence: any) {
            let value:string = stringify(sentence);
            
            if(transitionalWordRegex.test(value)){
                transitionalPhraseCount++;
            }
            
            totalSentanceCount++;
            
            return visit.SKIP;
        }

        if(totalSentanceCount === 0){
            return;
        }
    
        let transitionalWords:TextAnalysis = getTransitionalWordText(Math.round((transitionalPhraseCount / totalSentanceCount) * 100));
        
        if(transitionalWords.result === TextAnalysisResult.improvement){
            file.improvements.push(transitionalWords);
        } else {
            file.goodResults.push(transitionalWords);
        }

    }
        function getTransitionalWordText(percentage:number) {
            let result:TextAnalysis = {title: TextAnalysisCategory.transitional_words, displayText: "", helperText: "Percentage based on number on transitional words or phrases found"};
            if(percentage < 30) {
                result.displayText = `Only ${percentage}% of your sentences contain a transitional word or phrase, which is less than the recommended minimum of 30%.`;
                result.result = TextAnalysisResult.improvement;
            } else {
                result.displayText = `Great! You are using enough transitional words or phrases.`;
                result.result = TextAnalysisResult.goodResult;
            }
            return result;
    }
}